import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {FulltextSearchField, ValueType} from '@/api/meta/filters';
import {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import {computed, ref} from 'vue';
import DatePicker from '../DatePicker.vue';
import Sorter from '../Sorter.vue';
import {useFilterSort} from '@/composables/filterSort';
import usePicklistsStore from '@/store/picklists';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPicklist',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = usePicklistsStore();
const emits = __emit;
const {save, reset, filters, sorts, SortTypes} = useFilterSort(store, emits);

const allSearchInItems = ref<Array<{ text: string, value: FulltextSearchField }>>([
  {
    text: 'Tour-Nr.',
    value: {
      path: ['Tour', 'Tournr'],
      valueType: ValueType.Naked,
    },
  },
  {
    text: 'Picklisten-Nr.',
    value: {
      path: ['Picklistnr'],
      valueType: ValueType.Naked,
    },
  },
  {
    text: 'Bediener',
    value: {
      path: ['Kmsbediener'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'KFZ-Kennzeichen',
    value: {
      path: ['Tour/KfzKennzeichen'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'Auftrag-Nr.',
    value: {
      path: ['Auftraege', 'Belegnr'],
      valueType: ValueType.Naked,
    },
  },
  {
    text: 'Beleg-Nr. (intern)',
    value: {
      path: ['InterneAuftraege', 'Belegnr'],
      valueType: ValueType.Naked,
    },
  },
  {
    text: 'Kunde',
    value: {
      path: ['Auftraege', 'Name'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'Niederlassung / Lager',
    value: {
      path: ['InterneAuftraege', 'Name'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'Kennzeichen',
    value: {
      path: ['Tour', 'KfzKennzeichen'],
      valueType: ValueType.StringContains,
    },
  },
]);

const statusTypes = ref([
  {
    text: 'offen',
    value: ApiPicklistState.Todo,
    color: 'primary',
  },
  {
    text: 'in Bearbeitung',
    value: ApiPicklistState.Active,
    color: 'primary-lighten-1',
    icon: 'lock',
  },
  {
    text: 'erledigt',
    value: ApiPicklistState.Done,
    color: 'success',
    icon: 'check-circle',
  },
  {
    text: 'geparkt',
    value: ApiPicklistState.Parked,
    color: 'orange-accent-4',
    icon: 'pause-circle',
  },
]);
const picklistTypes = ref([
  {
    text: 'Aufträge',
    value: ApiPicklistType.Order,
  },
  {
    text: 'Interne Aufträge',
    value: ApiPicklistType.Internal,
  },
  {
    text: 'Touren',
    value: ApiPicklistType.Tour,
  },
]);
const sortableFields = ref([
  {
    text: 'Picklisten Nr.',
    value: 'Picklistnr',
  },
  {
    text: 'Datum',
    value: 'Kmsdatum',
  },
  {
    text: 'Priorität',
    value: 'Kmsprioritaet',
  },
]);

const fulltextSearch = computed({
  set(sWord: string) {
    const words = (sWord ?? '').split(' ').filter((w) => !!w);
    filters.value.Fulltext$Fulltext.words = words;
  },
  get(): string {
    const words = filters.value.Fulltext$Fulltext.words;

    return words.join(' ');
  },
});
const Bediener = computed({
  get() {
    return filters.value.Kmsbediener;
  },
  set(val: string | null | undefined) {
    if (!val) filters.value.Kmsbediener = undefined;
    else filters.value.Kmsbediener = val.toUpperCase();
  },
});

function ruleUserShort(val: string | undefined | null): string|true {
  if (!val) return true;

  if (val.length > 5) return 'zu lang';

  return true;
}

__expose({
  ruleUserShort,
  Sorter, DatePicker,
  store,
  save, reset, filters, sorts, SortTypes,
  allSearchInItems,
  statusTypes,
  picklistTypes,
  sortableFields,
  fulltextSearch,
  Bediener,
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-filter")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(" Filter "),
          _createVNode(_component_v_icon, {
            onClick: _unref(save),
            class: "ml-auto",
            end: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "px-3 py-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(Sorter, {
                modelValue: _unref(sorts),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sorts) ? (sorts).value = $event : null)),
                sortableFields: sortableFields.value,
                SortTypes: _unref(SortTypes)
              }, null, 8, ["modelValue", "sortableFields", "SortTypes"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: fulltextSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fulltextSearch).value = $event)),
                variant: "outlined",
                "hide-details": "",
                placeholder: "Freitextsuche",
                class: "mb-4",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (fulltextSearch.value = ''))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_select, {
                variant: "plain",
                messages: "",
                density: "compact",
                class: "mt-n3",
                items: allSearchInItems.value,
                multiple: "",
                "item-title": "text",
                "item-value": "value",
                modelValue: _unref(filters).Fulltext$Fulltext.fields,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).Fulltext$Fulltext.fields) = $event)),
                clearable: "",
                "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (_unref(filters).Fulltext$Fulltext.fields = []))
              }, {
                selection: _withCtx(({ item }) => [
                  _createVNode(_component_v_chip, {
                    variant: "outlined",
                    class: "black--color",
                    color: "grey",
                    size: "x-small"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["items", "modelValue"]),
              _createVNode(_component_v_select, {
                modelValue: _unref(filters).Status$In,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).Status$In) = $event)),
                variant: "outlined",
                placeholder: "Status filtern",
                label: "Status",
                items: statusTypes.value,
                multiple: "",
                "item-title": "text",
                "item-value": "value",
                clearable: "",
                "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (_unref(filters).Status$In = []))
              }, {
                chip: _withCtx(({ item }) => [
                  _createVNode(_component_v_chip, { size: "small" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        color: item.raw.color,
                        variant: "flat",
                        size: 12,
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: item.raw.icon
                          }, null, 8, ["icon"])
                        ], undefined, true),
                        _: 2
                      }, 1032, ["color"]),
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["modelValue", "items"]),
              _createVNode(_component_v_select, {
                label: "Picklistenart",
                variant: "outlined",
                items: picklistTypes.value,
                multiple: "",
                "item-title": "text",
                "item-value": "value",
                modelValue: _unref(filters).Art$In,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filters).Art$In) = $event)),
                clearable: "",
                "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (_unref(filters).Art$In = []))
              }, {
                selection: _withCtx(({ item }) => [
                  _createVNode(_component_v_chip, {
                    theme: "dark",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["items", "modelValue"]),
              _createVNode(DatePicker, {
                modelValue: _unref(filters).Kmsdatum$From,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(filters).Kmsdatum$From) = $event)),
                label: "Datum von",
                "onClick:append": _cache[10] || (_cache[10] = ($event: any) => (_unref(filters).Kmsdatum$From = undefined))
              }, null, 8, ["modelValue"]),
              _createVNode(DatePicker, {
                modelValue: _unref(filters).Kmsdatum$To,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(filters).Kmsdatum$To) = $event)),
                label: "Datum bis",
                "onClick:append": _cache[12] || (_cache[12] = ($event: any) => (_unref(filters).Kmsdatum$To = undefined))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: Bediener.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((Bediener).value = $event)),
                rules: [ruleUserShort],
                variant: "outlined",
                "hide-details": "",
                label: "Bediener",
                maxlength: "5",
                clearable: ""
              }, null, 8, ["modelValue", "rules"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "grey",
            class: "flex-1",
            variant: "outlined",
            size: "large",
            onClick: _unref(reset)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Zurücksetzen")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "flex-1 btn-navigator-primary",
            size: "large",
            onClick: _unref(save)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Speichern")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})